module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-blob-4-e8acfe60f626ca00af34cde2e5092a58.svg";